import { CountryState } from '../app/shared/models/lookup-country-states.model';

const mockCountryStates: CountryState[] = [{
  id: 1,
  code: `AL`,
  name: `Alabama`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 2,
  code: `AK`,
  name: `Alaska`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 3,
  code: `AZ`,
  name: `Arizona`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 4,
  code: `AR`,
  name: `Arkansas`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 5,
  code: `CA`,
  name: `California`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 7,
  code: `CO`,
  name: `Colorado`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 8,
  code: `CT`,
  name: `Connecticut`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 9,
  code: `DE`,
  name: `Delaware`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 10,
  code: `DC`,
  name: `District of Columbia`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 11,
  code: `FL`,
  name: `Florida`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 12,
  code: `GA`,
  name: `Georgia`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 13,
  code: `HI`,
  name: `Hawaii`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 14,
  code: `ID`,
  name: `Idaho`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 15,
  code: `IL`,
  name: `Illinois`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 16,
  code: `IN`,
  name: `Indiana`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 17,
  code: `IA`,
  name: `Iowa`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 18,
  code: `KS`,
  name: `Kansas`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 19,
  code: `KY`,
  name: `Kentucky`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 20,
  code: `LA`,
  name: `Louisiana`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 21,
  code: `ME`,
  name: `Maine`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 22,
  code: `MD`,
  name: `Maryland`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 23,
  code: `MA`,
  name: `Massachusetts`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 24,
  code: `MI`,
  name: `Michigan`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 25,
  code: `MN`,
  name: `Minnesota`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 26,
  code: `MS`,
  name: `Mississippi`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 27,
  code: `MO`,
  name: `Missouri`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 28,
  code: `MT`,
  name: `Montana`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 29,
  code: `NE`,
  name: `Nebraska`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 30,
  code: `NV`,
  name: `Nevada`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 31,
  code: `NH`,
  name: `New Hampshire`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 32,
  code: `NJ`,
  name: `New Jersey`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 33,
  code: `NM`,
  name: `New Mexico`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 34,
  code: `NY`,
  name: `New York`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 35,
  code: `NC`,
  name: `North Carolina`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 36,
  code: `ND`,
  name: `North Dakota`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 37,
  code: `OH`,
  name: `Ohio`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 38,
  code: `OK`,
  name: `Oklahoma`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 39,
  code: `OR`,
  name: `Oregon`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 40,
  code: `PA`,
  name: `Pennsylvania`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 41,
  code: `RI`,
  name: `Rhode Island`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 42,
  code: `SC`,
  name: `South Carolina`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 43,
  code: `SD`,
  name: `South Dakota`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 44,
  code: `TN`,
  name: `Tennessee`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 45,
  code: `TX`,
  name: `Texas`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 46,
  code: `UT`,
  name: `Utah`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 47,
  code: `VT`,
  name: `Vermont`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 48,
  code: `VA`,
  name: `Virginia`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 49,
  code: `WA`,
  name: `Washington`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 50,
  code: `WV`,
  name: `West Virginia`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 51,
  code: `WI`,
  name: `Wisconsin`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 52,
  code: `WY`,
  name: `Wyoming`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 53,
  code: `PR`,
  name: `Puerto Rico`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 54,
  code: `VI`,
  name: `Virgin Islands`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 55,
  code: `MP`,
  name: `Northern Mariana Islands`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 56,
  code: `GU`,
  name: `Guam`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 57,
  code: `AS`,
  name: `American Samoa`,
  countryId: 1,
  country: null,
  countryStateLicensure: null
}, {
  id: 58,
  code: `SE`,
  name: `San José`,
  countryId: 2,
  country: null,
  countryStateLicensure: null
}];

export default mockCountryStates;
